import {omit} from 'ramda';

import type {GetMyKanbanSelectedUsersApiResponse} from '@dms/api/core';
import type {GetCurrentUserInfoApiResponse, UserResponseBody} from '@dms/api/shared';
import {getNaturalPersonFullName} from '@dms/shared';

import {EMPTY_PLACEHOLDER, type Nullish} from 'shared/web';

type GetSelectedKanbanUsersParams = {
  users: UserResponseBody[] | Nullish;
  selectedUsers: GetMyKanbanSelectedUsersApiResponse | Nullish;
  currentUserData: GetCurrentUserInfoApiResponse | Nullish;
};

export function getSelectedKanbanUsers({
  users,
  selectedUsers,
  currentUserData,
}: GetSelectedKanbanUsersParams) {
  if (!currentUserData) {
    return [];
  }

  const currentUser = {
    ...omit(['settings', 'firstName', 'lastName'], currentUserData),
    fullName:
      getNaturalPersonFullName({
        firstName: currentUserData.firstName,
        lastName: currentUserData.lastName,
      }) || EMPTY_PLACEHOLDER,
    isHidden: !!selectedUsers?.find((user) => user.userId === currentUserData.id)?.isHidden,
  };

  if (!users?.length || !selectedUsers?.length) {
    return [currentUser];
  }

  const selectedKanbanUsers = selectedUsers
    .map((selectedUser) => {
      const user = users.find(
        (user) => user.id === selectedUser.userId && user.id !== currentUser.id && !user.blocked
      );

      if (!user) {
        return null;
      }

      return {
        ...omit(['firstName', 'lastName', 'blocked'], user),
        fullName:
          getNaturalPersonFullName({
            firstName: user.firstName,
            lastName: user.lastName,
          }) || EMPTY_PLACEHOLDER,
        isHidden: selectedUser.isHidden,
      };
    })
    .filter(Boolean);

  return [currentUser, ...selectedKanbanUsers];
}
